import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";


class VirtualCare extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12">
                        <div className="hp-title maxWidth-content">
                            Virtual Care
                        </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12">
                        <div className="claim-wrapper">
                            <div className="claim-container">
                                <div className="row">
                                    <div className="col-12 maxWidth-content">
                                        Connect with MDLIVE, your 24/7 resource for easy, convenient online doctor visits. Doctors are available for help with more than 50 minor illnesses, from colds and
                                        sinus infections to allergies and more.
                                        <hr></hr>
                                        <div>
                                            MDLIVE is best viewed using current versions of Google Chrome, Firefox, Safari and/or Microsoft Edge. If you are using Microsoft Internet Explorer� (IE) or an older version of the browsers mentioned here, you may not experience the site's optimal functionality.
                                        </div>
                                        <hr></hr>
                                        <div>
                                            <button className="btn btn-primary" onClick={() => this.props.ssoTelemedicine()}>LAUNCH MDLIVE </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        ssoTelemedicine: () => dispatch({ type: types.HP_SSO_TELEMEDICINE_START }),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VirtualCare));